import moment from "moment";

const initalState = {
  update: Date.now(),
  serviceId: 0,
  modal: {},
  updatingData: {},
  fromDateSchedule: moment().subtract(45, 'days').format("YYYY-MM-DD"),
  toDateSchedule: moment()?.add(1, "days").format("YYYY-MM-DD"),
  fromDateClaim: moment().subtract(45, 'days').format("YYYY-MM-DD"),
  toDateClaim: moment()?.add(1, "days").format("YYYY-MM-DD"),
  transferStatus:'all'
};

const reducer = (state = initalState, action) => {
   console.log(state, action, "Reducer")
  switch (action.type) {
    case "CHANGEMODALSTATE":
      return {
        ...state,
        ...action?.payload,
        modal: action?.payload,
        updatingData: action?.payload?.updatingData || {},
      };
    case "CHANGEDATASTATE":
      return { ...state, ...action?.payload };
    case "CHANGESTATE":
      return {
        ...state,
        ...action?.payload,
      };
    default:
      return state;
  }
};

export { reducer };
